import React from 'react'

import COLORS from '../../styles/colors'
import { SVGProps } from '../../types/svg'

const defaultSize = {
  width: 30,
  height: 30,
}

const Apartment = ({ style = {}, color = COLORS.brand.primaryDark }: SVGProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 43.738 43.739'
  >
    <g fill={color}>
      <path
        d='M140.607,477.867H120.2a.729.729,0,0,0-.729.729v1.458a.729.729,0,1,0,1.458,0v-.729h19.682a.729.729,0,0,0,0-1.458Z'
        transform='translate(-109.261 -437.044)'
      />
      <path
        d='M187.733,158.7a.729.729,0,0,0,.729.729h2.916a.729.729,0,0,0,.729-.729v-4.374a.729.729,0,0,0-.729-.729h-2.916a.729.729,0,0,0-.729.729V158.7Zm1.458-3.645h1.458v2.916h-1.458Z'
        transform='translate(-171.696 -140.478)'
      />
      <path
        d='M9.477,102.4H.729a.729.729,0,0,0-.729.729v14.579a.729.729,0,1,0,1.458,0v-13.85H9.477a.729.729,0,0,0,0-1.458Z'
        transform='translate(0 -93.652)'
      />
      <path
        d='M409.6,363.5a.729.729,0,0,0,.729.729h2.916a.729.729,0,0,0,.729-.729v-4.374a.729.729,0,0,0-.729-.729h-2.916a.729.729,0,0,0-.729.729Zm1.458-3.645h1.458v2.916h-1.458Z'
        transform='translate(-374.609 -327.783)'
      />
      <path
        d='M3.645,307.2C.042,307.2,0,316.582,0,316.677a3.651,3.651,0,0,0,2.916,3.571v3.718a.729.729,0,0,0,1.458,0v-3.718a3.651,3.651,0,0,0,2.916-3.571C7.29,316.582,7.248,307.2,3.645,307.2Zm0,11.664a2.19,2.19,0,0,1-2.187-2.187c0-3.632.975-8.019,2.187-8.019s2.187,4.387,2.187,8.019A2.19,2.19,0,0,1,3.645,318.864Z'
        transform='translate(0 -280.957)'
      />
      <path
        d='M54.845,256H51.929a.729.729,0,0,0-.729.729v1.458a.729.729,0,0,0,1.458,0v-.729h1.458V261.1a.729.729,0,0,0,1.458,0v-4.374A.729.729,0,0,0,54.845,256Z'
        transform='translate(-46.826 -234.131)'
      />
      <path
        d='M410.329,159.433h2.916a.729.729,0,0,0,.729-.729V154.33a.729.729,0,0,0-.729-.729h-2.916a.729.729,0,0,0-.729.729V158.7A.729.729,0,0,0,410.329,159.433Zm.729-4.374h1.458v2.916h-1.458Z'
        transform='translate(-374.609 -140.479)'
      />
      <path
        d='M54.845,153.6H51.929a.729.729,0,0,0-.729.729V158.7a.729.729,0,0,0,.729.729h2.916a.729.729,0,0,0,.729-.729v-4.374A.729.729,0,0,0,54.845,153.6Zm-.729,4.374H52.658v-2.916h1.458v2.916Z'
        transform='translate(-46.826 -140.478)'
      />
      <path
        d='M273.067,158.7a.729.729,0,0,0,.729.729h2.916a.729.729,0,0,0,.729-.729v-4.374a.729.729,0,0,0-.729-.729H273.8a.729.729,0,0,0-.729.729Zm1.458-3.645h1.458v2.916h-1.458Z'
        transform='translate(-249.74 -140.478)'
      />
      <path
        d='M402.011,102.4h-8.748a.729.729,0,1,0,0,1.458h8.019v29.293a2.082,2.082,0,0,0-1.1-.1,2.911,2.911,0,0,0-5.082,0,2.14,2.14,0,0,0-.375-.033,2.187,2.187,0,0,0,0,4.374h5.832a2.19,2.19,0,0,0,2.187-2.187V103.129A.729.729,0,0,0,402.011,102.4Zm-1.458,33.533h-5.832a.729.729,0,1,1,0-1.458.72.72,0,0,1,.4.119.729.729,0,0,0,1.105-.448,1.452,1.452,0,0,1,2.831,0,.729.729,0,0,0,1.105.448.743.743,0,0,1,1.124.61A.73.73,0,0,1,400.553,135.933Z'
        transform='translate(-359.001 -93.652)'
      />
      <path
        d='M273.8,57.033h2.916a.729.729,0,0,0,.729-.729V51.93a.729.729,0,0,0-.729-.729H273.8a.729.729,0,0,0-.729.729V56.3A.729.729,0,0,0,273.8,57.033Zm.729-4.374h1.458v2.916h-1.458Z'
        transform='translate(-249.74 -46.827)'
      />
      <path
        d='M273.067,261.1a.729.729,0,0,0,.729.729h2.916a.729.729,0,0,0,.729-.729v-4.374a.729.729,0,0,0-.729-.729H273.8a.729.729,0,0,0-.729.729Zm1.458-3.645h1.458v2.916h-1.458Z'
        transform='translate(-249.74 -234.131)'
      />
      <path
        d='M188.463,57.033h2.916a.729.729,0,0,0,.729-.729V51.93a.729.729,0,0,0-.729-.729h-2.916a.729.729,0,0,0-.729.729V56.3A.729.729,0,0,0,188.463,57.033Zm.729-4.374h1.458v2.916h-1.458Z'
        transform='translate(-171.697 -46.827)'
      />
      <path
        d='M247.677,409.909a.729.729,0,1,0,1.035,0A.767.767,0,0,0,247.677,409.909Z'
        transform='translate(-226.326 -374.707)'
      />
      <path
        d='M187.733,261.1a.729.729,0,0,0,.729.729h2.916a.729.729,0,0,0,.729-.729v-4.374a.729.729,0,0,0-.729-.729h-2.916a.729.729,0,0,0-.729.729V261.1Zm1.458-3.645h1.458v2.916h-1.458Z'
        transform='translate(-171.696 -234.131)'
      />
      <path
        d='M170.667,359.129a.729.729,0,0,0,.729.729h2.187v6.561a.729.729,0,0,0,1.458,0v-6.561h5.832v6.561a.729.729,0,1,0,1.458,0v-6.561h2.187a.729.729,0,0,0,0-1.458H171.4A.729.729,0,0,0,170.667,359.129Z'
        transform='translate(-156.087 -327.783)'
      />
      <path
        d='M409.6,261.1a.729.729,0,0,0,.729.729h2.916a.729.729,0,0,0,.729-.729v-4.374a.729.729,0,0,0-.729-.729h-2.916a.729.729,0,0,0-.729.729Zm1.458-3.645h1.458v2.916h-1.458Z'
        transform='translate(-374.609 -234.131)'
      />
      <path
        d='M156.216,0H137.263a.729.729,0,0,0-.729.729V38.636a.729.729,0,0,0,1.458,0V1.458h17.5V38.636a.729.729,0,1,0,1.458,0V.729A.729.729,0,0,0,156.216,0Z'
        transform='translate(-124.87)'
      />
    </g>
  </svg>
)

export default Apartment
